import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraIds: number[]
  enabled?: boolean
  startDate: number
  endDate: number
}

export default function useGetRetentionRange({cameraIds, startDate, endDate, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    retry: 0,
    queryKey: [QueryKeyEnum.RETENTION_RANGES, cameraIds, startDate, endDate],
    queryFn: async () => {
      return api.streaming.getRangeRetention({cameraIds, startDate, endDate})
    },
  })

  return query
}
